var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgNpm(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 256 100",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMinYMin meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0v85.498h71.166V99.83H128V85.498h128V0H0z",
    fill: "#CB3837"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.502 14.332h-28.17v56.834h28.17V28.664h14.332v42.502h14.332V14.332H42.502zm42.996 0v71.166h28.664V71.166h28.17V14.332H85.498zM128 56.834h-13.838v-28.17H128v28.17zm56.834-42.502h-28.17v56.834h28.17V28.664h14.332v42.502h14.332V28.664h14.332v42.502h14.332V14.332h-57.328z",
    fill: "#FFF"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB2aWV3Qm94PSIwIDAgMjU2IDEwMCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiBwcmVzZXJ2ZUFzcGVjdFJhdGlvPSJ4TWluWU1pbiBtZWV0Ij4KICA8cGF0aCBkPSJNMCAwdjg1LjQ5OGg3MS4xNjZWOTkuODNIMTI4Vjg1LjQ5OGgxMjhWMEgweiIgZmlsbD0iI0NCMzgzNyIvPgogIDxwYXRoIGQ9Ik00Mi41MDIgMTQuMzMyaC0yOC4xN3Y1Ni44MzRoMjguMTdWMjguNjY0aDE0LjMzMnY0Mi41MDJoMTQuMzMyVjE0LjMzMkg0Mi41MDJ6bTQyLjk5NiAwdjcxLjE2NmgyOC42NjRWNzEuMTY2aDI4LjE3VjE0LjMzMkg4NS40OTh6TTEyOCA1Ni44MzRoLTEzLjgzOHYtMjguMTdIMTI4djI4LjE3em01Ni44MzQtNDIuNTAyaC0yOC4xN3Y1Ni44MzRoMjguMTdWMjguNjY0aDE0LjMzMnY0Mi41MDJoMTQuMzMyVjI4LjY2NGgxNC4zMzJ2NDIuNTAyaDE0LjMzMlYxNC4zMzJoLTU3LjMyOHoiIGZpbGw9IiNGRkYiLz4KPC9zdmc+";
export { SvgNpm as ReactComponent };